import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface FooterProps {
  onClose: () => void
  disabled: boolean
}

const Footer = ({ onClose, disabled }: FooterProps) => {
  return (
    <>
      <Button onClick={onClose} type="secondary">
        {i18n.t('common.cancel')}
      </Button>
      <Button disabled={disabled} submit>
        {i18n.t('time_off.allowances.page.button.setup')}
      </Button>
    </>
  )
}

interface Props {
  onClose: () => void
  onSubmit: (payload: unknown) => void
}

const NewAllowanceModal = ({ onClose, onSubmit }: Props) => {
  const allowanceForm = React.useRef(
    new Form(
      {
        name: null,
      },
      {
        name: 'string',
      }
    )
  ).current

  const submit = React.useCallback(async () => {
    const payload = {
      allowanceName: allowanceForm.get('name').value,
    }
    onSubmit(payload)
  }, [allowanceForm, onSubmit])

  const disabled = !allowanceForm.get('name').value

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('time_off.allowances.modal.new.title')}
      description={i18n.t('time_off.allowances.modal.new.description')}
      onClose={onClose}
      onSubmit={submit}
      footer={<Footer onClose={onClose} disabled={disabled} />}
    >
      <FormRow>
        <Text
          label={i18n.t('time_off.allowances.labels.name')}
          field={allowanceForm.get('name')}
          mandatory
        />
      </FormRow>
    </Modal>
  )
}

export default observer(NewAllowanceModal)
